import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UNA from '../theme';

const datosIniciales = {
  talleres: [
    {
      id: 1,
      titulo: 'Introducción a Python',
      descripcion: 'Aprende los fundamentos de Python desde cero.',
      categoria: 'Programación',
      duracion: '8 horas',
      modulos: [
        { id: 1, titulo: 'Variables y tipos de datos', tipo: 'video', duracion: '25 min', url: 'https://youtube.com' },
        { id: 2, titulo: 'Estructuras de control', tipo: 'video', duracion: '30 min', url: 'https://youtube.com' },
        { id: 3, titulo: 'Ejercicio: Calculadora básica', tipo: 'ejercicio', duracion: '20 min', url: '' },
        { id: 4, titulo: 'Test del módulo 1', tipo: 'test', duracion: '15 min', url: '' },
      ]
    },
    {
      id: 2,
      titulo: 'Estadística Aplicada',
      descripcion: 'Conceptos fundamentales de estadística con aplicaciones reales.',
      categoria: 'Matemática',
      duracion: '10 horas',
      modulos: []
    }
  ],
  grupos: [
    { id: 1, tallerId: 1, nombre: 'Python - Mayo 2026', inicio: '2026-05-01', fin: '2026-06-30', estudiantes: 12 },
    { id: 2, tallerId: 2, nombre: 'Estadística - Mayo 2026', inicio: '2026-05-15', fin: '2026-06-15', estudiantes: 8 },
  ]
};

const tipoColor = {
  video:     { bg: '#e8f5e9', color: '#2e7d32', label: '🎬 Video' },
  ejercicio: { bg: '#fff8e1', color: '#e65100', label: '✏️ Ejercicio' },
  test:      { bg: UNA.rojoClaro, color: UNA.rojo, label: '📝 Test' },
};

function Btn({ children, onClick, variante = 'primario', disabled = false, style = {} }) {
  const estilos = {
    primario:   { background: UNA.rojo, color: 'white' },
    secundario: { background: '#f0f0f0', color: '#444' },
    peligro:    { background: UNA.rojoClaro, color: UNA.rojo },
  };
  return (
    <button onClick={onClick} disabled={disabled}
      style={{ border: 'none', padding: '9px 18px', borderRadius: '8px', cursor: disabled ? 'not-allowed' : 'pointer', fontWeight: '600', fontSize: '13px', opacity: disabled ? 0.5 : 1, ...estilos[variante], ...style }}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.opacity = '0.85'; }}
      onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}>
      {children}
    </button>
  );
}

function MisTalleres({ datos, setDatos, setSeccion, setTallerActivo }) {
  const [mostrarForm, setMostrarForm] = useState(false);
  const [form, setForm] = useState({ titulo: '', descripcion: '', categoria: 'Programación', duracion: '' });

  const agregar = () => {
    if (!form.titulo || !form.descripcion) return;
    setDatos(d => ({ ...d, talleres: [...d.talleres, { ...form, id: Date.now(), modulos: [] }] }));
    setForm({ titulo: '', descripcion: '', categoria: 'Programación', duracion: '' });
    setMostrarForm(false);
  };

  const eliminar = (id) => setDatos(d => ({ ...d, talleres: d.talleres.filter(t => t.id !== id) }));

  const abrirTaller = (taller) => {
    setTallerActivo(taller);
    setSeccion('modulos');
  };

  const inputStyle = { width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: '1.8rem', color: UNA.texto }}>Mis Talleres</h1>
          <p style={{ color: UNA.textoSuave, margin: '4px 0 0' }}>Crea y edita el contenido de tus talleres</p>
        </div>
        <Btn onClick={() => setMostrarForm(!mostrarForm)}>+ Nuevo taller</Btn>
      </div>

      {mostrarForm && (
        <div style={{ background: 'white', borderRadius: '12px', padding: '1.5rem', marginBottom: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
            <div>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>Título del taller</label>
              <input value={form.titulo} onChange={e => setForm({ ...form, titulo: e.target.value })}
                placeholder="Ej: Introducción a Python" style={inputStyle}
                onFocus={e => e.target.style.borderColor = UNA.rojo}
                onBlur={e => e.target.style.borderColor = '#ddd'} />
            </div>
            <div>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>Categoría</label>
              <select value={form.categoria} onChange={e => setForm({ ...form, categoria: e.target.value })} style={inputStyle}>
                <option>Programación</option>
                <option>Matemática</option>
                <option>Ofimática</option>
                <option>Ciencias</option>
                <option>Otro</option>
              </select>
            </div>
            <div>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>Duración estimada</label>
              <input value={form.duracion} onChange={e => setForm({ ...form, duracion: e.target.value })}
                placeholder="Ej: 8 horas" style={inputStyle}
                onFocus={e => e.target.style.borderColor = UNA.rojo}
                onBlur={e => e.target.style.borderColor = '#ddd'} />
            </div>
            <div>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>Descripción</label>
              <input value={form.descripcion} onChange={e => setForm({ ...form, descripcion: e.target.value })}
                placeholder="Descripción breve del taller" style={inputStyle}
                onFocus={e => e.target.style.borderColor = UNA.rojo}
                onBlur={e => e.target.style.borderColor = '#ddd'} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <Btn onClick={agregar}>Guardar taller</Btn>
            <Btn onClick={() => setMostrarForm(false)} variante="secundario">Cancelar</Btn>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gap: '1rem' }}>
        {datos.talleres.map(t => (
          <div key={t.id} style={{ background: 'white', borderRadius: '16px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderLeft: `5px solid ${UNA.rojo}` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                  <h3 style={{ margin: 0, color: UNA.texto }}>{t.titulo}</h3>
                  <span style={{ fontSize: '11px', background: UNA.rojoClaro, color: UNA.rojo, padding: '3px 10px', borderRadius: '12px', fontWeight: '600' }}>{t.categoria}</span>
                </div>
                <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#888' }}>{t.descripcion}</p>
                <div style={{ display: 'flex', gap: '1.5rem', fontSize: '13px', color: '#aaa' }}>
                  <span>⏱ {t.duracion || 'Sin duración'}</span>
                  <span>📦 {t.modulos.length} módulos</span>
                  <span>🧑‍🤝‍🧑 {datos.grupos.filter(g => g.tallerId === t.id).length} grupos</span>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <Btn onClick={() => abrirTaller(t)}>Editar contenido</Btn>
                <Btn onClick={() => eliminar(t.id)} variante="peligro">Eliminar</Btn>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function EditorModulos({ taller, datos, setDatos, setSeccion }) {
  const [mostrarForm, setMostrarForm] = useState(false);
  const [form, setForm] = useState({ titulo: '', tipo: 'video', duracion: '', url: '' });

  const inputStyle = { width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' };

  const agregarModulo = () => {
    if (!form.titulo) return;
    setDatos(d => ({
      ...d,
      talleres: d.talleres.map(t =>
        t.id === taller.id ? { ...t, modulos: [...t.modulos, { ...form, id: Date.now() }] } : t
      )
    }));
    setForm({ titulo: '', tipo: 'video', duracion: '', url: '' });
    setMostrarForm(false);
  };

  const eliminarModulo = (moduloId) => {
    setDatos(d => ({
      ...d,
      talleres: d.talleres.map(t =>
        t.id === taller.id ? { ...t, modulos: t.modulos.filter(m => m.id !== moduloId) } : t
      )
    }));
  };

  const tallerActualizado = datos.talleres.find(t => t.id === taller.id);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.5rem' }}>
        <Btn onClick={() => setSeccion('talleres')} variante="secundario">← Volver</Btn>
        <div>
          <h1 style={{ margin: 0, fontSize: '1.8rem', color: UNA.texto }}>{taller.titulo}</h1>
          <p style={{ color: UNA.textoSuave, margin: '4px 0 0', fontSize: '13px' }}>Editor de módulos y contenido</p>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
        <Btn onClick={() => setMostrarForm(!mostrarForm)}>+ Agregar módulo</Btn>
      </div>

      {mostrarForm && (
        <div style={{ background: 'white', borderRadius: '12px', padding: '1.5rem', marginBottom: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
            <div>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>Título del módulo</label>
              <input value={form.titulo} onChange={e => setForm({ ...form, titulo: e.target.value })}
                placeholder="Ej: Variables y tipos de datos" style={inputStyle}
                onFocus={e => e.target.style.borderColor = UNA.rojo}
                onBlur={e => e.target.style.borderColor = '#ddd'} />
            </div>
            <div>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>Tipo de contenido</label>
              <select value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value })} style={inputStyle}>
                <option value="video">🎬 Video</option>
                <option value="ejercicio">✏️ Ejercicio</option>
                <option value="test">📝 Test</option>
              </select>
            </div>
            <div>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>Duración estimada</label>
              <input value={form.duracion} onChange={e => setForm({ ...form, duracion: e.target.value })}
                placeholder="Ej: 25 min" style={inputStyle}
                onFocus={e => e.target.style.borderColor = UNA.rojo}
                onBlur={e => e.target.style.borderColor = '#ddd'} />
            </div>
            <div>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>
                {form.tipo === 'video' ? 'URL del video (YouTube)' : 'URL del recurso (opcional)'}
              </label>
              <input value={form.url} onChange={e => setForm({ ...form, url: e.target.value })}
                placeholder="https://..." style={inputStyle}
                onFocus={e => e.target.style.borderColor = UNA.rojo}
                onBlur={e => e.target.style.borderColor = '#ddd'} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <Btn onClick={agregarModulo}>Guardar módulo</Btn>
            <Btn onClick={() => setMostrarForm(false)} variante="secundario">Cancelar</Btn>
          </div>
        </div>
      )}

      <div style={{ background: 'white', borderRadius: '16px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        {tallerActualizado?.modulos.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem', color: '#aaa' }}>
            <p style={{ fontSize: '2rem', margin: '0 0 1rem' }}>📦</p>
            <p>Este taller no tiene módulos aún. ¡Agrega el primero!</p>
          </div>
        ) : (
          tallerActualizado?.modulos.map((m, i) => {
            const tipo = tipoColor[m.tipo];
            return (
              <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '14px 0', borderBottom: '1px solid #f0f0f0' }}>
                <div style={{ width: '32px', height: '32px', background: UNA.rojoClaro, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', color: UNA.rojo, fontSize: '13px', flexShrink: 0 }}>
                  {i + 1}
                </div>
                <div style={{ flex: 1 }}>
                  <p style={{ margin: 0, fontWeight: '500', color: UNA.texto }}>{m.titulo}</p>
                  <div style={{ display: 'flex', gap: '10px', marginTop: '4px', alignItems: 'center' }}>
                    <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: tipo.bg, color: tipo.color, fontWeight: '600' }}>{tipo.label}</span>
                    {m.duracion && <span style={{ fontSize: '12px', color: '#aaa' }}>⏱ {m.duracion}</span>}
                    {m.url && <a href={m.url} target="_blank" rel="noreferrer" style={{ fontSize: '12px', color: UNA.rojo }}>Ver enlace →</a>}
                  </div>
                </div>
                <Btn onClick={() => eliminarModulo(m.id)} variante="peligro">Eliminar</Btn>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

function MisGrupos({ datos }) {
  return (
    <div>
      <h1 style={{ margin: '0 0 8px', fontSize: '1.8rem', color: UNA.texto }}>Mis Grupos</h1>
      <p style={{ color: UNA.textoSuave, marginBottom: '1.5rem' }}>Grupos en los que estás asignado como instructor</p>
      <div style={{ display: 'grid', gap: '1rem' }}>
        {datos.grupos.map(g => {
          const taller = datos.talleres.find(t => t.id === g.tallerId);
          return (
            <div key={g.id} style={{ background: 'white', borderRadius: '16px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderLeft: `5px solid ${UNA.rojo}` }}>
              <h3 style={{ margin: '0 0 6px', color: UNA.texto }}>{g.nombre}</h3>
              <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#888' }}>📚 {taller?.titulo}</p>
              <div style={{ display: 'flex', gap: '1.5rem', fontSize: '13px', color: '#aaa' }}>
                <span>📅 {g.inicio} → {g.fin}</span>
                <span>🎓 {g.estudiantes} estudiantes</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function Instructor() {
  const navigate = useNavigate();
  const { usuario, logout } = useAuth();
  const [seccion, setSeccion] = useState('talleres');
  const [datos, setDatos] = useState(datosIniciales);
  const [tallerActivo, setTallerActivo] = useState(null);

  const menu = [
    { id: 'talleres', label: '📚 Mis talleres' },
    { id: 'grupos', label: '🧑‍🤝‍🧑 Mis grupos' },
  ];

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: 'Segoe UI, sans-serif', background: UNA.gris }}>

      {/* Sidebar */}
     {/* Sidebar */}
<div
  style={{
    width: '240px',
    background: UNA.rojo,
    color: 'white',
    padding: '2rem 1.2rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'fixed',
    height: '100vh',
    boxSizing: 'border-box'
  }}
>
  <div>

    {/* Header usuario */}
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '2rem'
      }}
    >

      {/* LOGO NUEVO */}
      <img
        src={require('../assets/logo_una.jpg')}
        alt="Logo UNA"
        style={{
          width: '42px',
          height: '42px',
          borderRadius: '8px',
          objectFit: 'cover',
          background: 'white',
          padding: '2px'
        }}
      />

      <div>
        <p
          style={{
            margin: 0,
            fontWeight: '700',
            fontSize: '15px'
          }}
        >
          Instructor
        </p>

        <p
          style={{
            margin: 0,
            fontSize: '11px',
            opacity: 0.75
          }}
        >
          {usuario?.nombre}
        </p>
      </div>
    </div>

    {/* Menú */}
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
      }}
    >
      {menu.map(m => (
        <button
          key={m.id}
          onClick={() => {
            setSeccion(m.id);
            setTallerActivo(null);
          }}
          style={{
            background:
              seccion === m.id
                ? 'rgba(255,255,255,0.2)'
                : 'transparent',
            border: 'none',
            color: 'white',
            padding: '12px',
            borderRadius: '8px',
            textAlign: 'left',
            cursor: 'pointer',
            fontSize: '15px',
            fontWeight: seccion === m.id ? '700' : '400',
            borderLeft:
              seccion === m.id
                ? '3px solid white'
                : '3px solid transparent'
          }}
          onMouseEnter={e => {
            if (seccion !== m.id)
              e.currentTarget.style.background =
                'rgba(255,255,255,0.1)';
          }}
          onMouseLeave={e => {
            if (seccion !== m.id)
              e.currentTarget.style.background =
                'transparent';
          }}
        >
          {m.label}
        </button>
      ))}
    </div>
  </div>

  {/* Logout */}
  <button
    onClick={handleLogout}
    style={{
      background: 'white',
      border: 'none',
      color: UNA.rojo,
      padding: '12px',
      borderRadius: '8px',
      cursor: 'pointer',
      fontWeight: '700'
    }}
  >
    Cerrar sesión
  </button>
</div>

      {/* Contenido */}
      <div style={{ flex: 1, padding: '2rem', marginLeft: '240px' }}>
        {seccion === 'talleres' && !tallerActivo &&
          <MisTalleres datos={datos} setDatos={setDatos} setSeccion={setSeccion} setTallerActivo={setTallerActivo} />}
        {seccion === 'modulos' && tallerActivo &&
          <EditorModulos taller={tallerActivo} datos={datos} setDatos={setDatos} setSeccion={(s) => { setSeccion(s); setTallerActivo(null); }} />}
        {seccion === 'grupos' &&
          <MisGrupos datos={datos} />}
      </div>
    </div>
  );
}